// src/components/UserDashboardView.tsx

import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { canUserCreateTicket, fetchUserTickets } from "../api";
import type { Ticket } from "../types";

import cardStyles from "../styles/Card.module.css";
import tableStyles from "../styles/Table.module.css";
import buttonStyles from "../styles/Button.module.css";
import toggleStyles from "../styles/Toggle.module.css";
import { GlobalContext } from "../App";
import { useAuth } from "react-oidc-context";

export default function UserDashboardView() {
  const auth = useAuth();
  const [tickets, setTickets] = useState<Ticket[]>([]);

  const {globalSite, setSite, ticketFilter, setTicketFilter} = useContext(GlobalContext);
  const [user, setUser] = useState<string>("");

  const [canCreateTickets, setCanCreateTickets] = useState<boolean>(false);

  const navigate = useNavigate();
  // const user = "DSD234";

  useEffect(() => {
    if (globalSite === undefined || globalSite === "") {
      if (typeof auth.user?.profile.site === "string") {
        setSite(auth.user?.profile.site)
        // setSite("serdov")
      }
      setUser(typeof auth.user?.profile.sentence === "string" ? auth.user.profile.sentence : "");
    }
  }, [globalSite, setSite, auth.user?.profile.site])

  useEffect(() => {
    if (globalSite !== undefined && user !== "") {
      fetchUserTickets(user, globalSite)
      .then((data) => {
        setTickets(data);
      })
      .catch((err) => console.error("Error fetching tickets:", err));
    }
  }, [globalSite]);

  useEffect(() => {
    if (globalSite !== undefined && user !== "") {
      canUserCreateTicket(globalSite, user).then((permission) => {
        if (typeof(permission) === "boolean") {
          setCanCreateTickets(permission)
        }
      })
    }
  }, [globalSite, user]);

  function newTicketButton() {
    return canCreateTickets && (
       <button
          onClick={() => navigate("/new-ticket")}
          className={`${buttonStyles.button} ${buttonStyles.primary}`}
        >
          New Ticket
        </button>
    )
  }

  const filteredTickets = tickets.filter((t) => {
    if (ticketFilter === "Closed" || ticketFilter === "Requested") {
      return t.status === ticketFilter
    } else {
      return t.status !== "Closed" && t.status !== "Requested"
    }
  });

  function displayStatus(t:Ticket) {
    if (t.status === "Closed") {
      return (<span className={buttonStyles.statusClosed}>Closed</span>)
    }
    if (t.status === "InProgress" || t.status === "EscalatedToUnify") {
      return <span className={buttonStyles.statusInProgress}>In Progress</span>
    }
    return <span className={buttonStyles.statusOpen}>Open</span>
  }

  function noTicketsMessage() {
    if (canCreateTickets) {
      return "No Tickets Found"
    }
    return "No Tickets Found - To raise a ticket contact a member of the Unify tech team"
  }

  return (
    <div className={cardStyles.card}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <h2>Tickets</h2>
        {newTicketButton()}
      </div>

      <div
        className={toggleStyles.toggleGroup}
        style={{ marginBottom: "16px" }}
      >
        <button
          className={`${toggleStyles.toggleButton} ${
            ticketFilter === "Requested" ? toggleStyles.active : ""
          }`}
          onClick={() => setTicketFilter("Requested")}
        >
          Open
        </button>
        <button
          className={`${toggleStyles.toggleButton} ${
            ticketFilter === "InProgress" ? toggleStyles.active : ""
          }`}
          onClick={() => setTicketFilter("InProgress")}
        >
          In Progress
        </button>
        <button
          className={`${toggleStyles.toggleButton} ${
            ticketFilter === "Closed" ? toggleStyles.active : ""
          }`}
          onClick={() => setTicketFilter("Closed")}
        >
          Closed
        </button>
      </div>

      <table className={tableStyles.table}>
        <thead>
          <tr>
            <th>Subject</th>
            <th>Ticket No</th>
            <th>User</th>
            <th>Requested</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredTickets.map((t) => (
            <tr
              key={t.id}
              onClick={() => navigate(`/dashboard/${globalSite}/${t.id}`)}
              style={{ cursor: "pointer" }}
            >
              <td>{t.faults[0]}</td>
              <td>#{t.id}</td>
              <td>{t.userName}</td>
              <td>{new Date(t.requested).toLocaleDateString()}</td>
              <td>
                {displayStatus(t)}
              </td>
            </tr>
          ))}

          {filteredTickets.length === 0 && (
            <tr>
              <td colSpan={5} style={{ textAlign: "center", padding: "16px" }}>
                {noTicketsMessage()}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}